<template>
  <div>
    Rachat de crédit
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'RachatCredit'
}
</script>
